export default __webpack_public_path__ + "static/media/background-account-creation.eb089456.png";